import React from 'react';
import PropTypes from 'prop-types';

import ShadedColorPaletteVertical from './ShadedColorPaletteVertical';
import PagedBrowser from '../../PagedBrowser';

const ShadedAreaLegendDetailed = props => {
    const { mapInstance, renderer} = props;
    const { nullDataRuleIndex, insufficientDataRuleIndex, rules } = renderer;

    const pages = [];
    const legendHighlighted = rules.some(rule => rule.highlighted);

    const shadedColorPaletteVertical = (
        <div
            key="shaded-color-palette"
            className="vertical-shaded-area-legend flex-it column"
        >
            <ShadedColorPaletteVertical
                mapInstanceId={mapInstance.id}
                nullDataRuleIndex={nullDataRuleIndex}
                insufficientDataRuleIndex={insufficientDataRuleIndex}
                rules={rules}
                legendHighlighted={legendHighlighted}
            />
        </div>
    );

    pages.push(shadedColorPaletteVertical);

    return (
        <PagedBrowser>
            {pages}
        </PagedBrowser>
    );
};

ShadedAreaLegendDetailed.propTypes = {
    renderer: PropTypes.object.isRequired,
    mapInstance: PropTypes.object.isRequired,
};

export default ShadedAreaLegendDetailed;
